import PropTypes from 'prop-types';

export function ReportsManagerIcon({ strokeColor = '#2f2f2f' }) {
  return (
    <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33337 13.3334C5.33337 14.0406 5.61433 14.7189 6.11442 15.219C6.61452 15.7191 7.2928 16 8.00004 16C8.70728 16 9.38556 15.7191 9.88566 15.219C10.3858 14.7189 10.6667 14.0406 10.6667 13.3334C10.6667 12.6261 10.3858 11.9478 9.88566 11.4477C9.38556 10.9476 8.70728 10.6667 8.00004 10.6667C7.2928 10.6667 6.61452 10.9476 6.11442 11.4477C5.61433 11.9478 5.33337 12.6261 5.33337 13.3334Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 5.33331V10.6666" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 16V26.6667" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M18.5934 20.7067C18.4758 20.2203 18.2237 19.7767 17.8659 19.4268C17.5081 19.0769 17.059 18.8348 16.5701 18.728C16.0811 18.6213 15.572 18.6543 15.101 18.8233C14.6299 18.9923 14.2159 19.2904 13.9063 19.6836C13.5967 20.0768 13.404 20.5491 13.3502 21.0467C13.2964 21.5442 13.3837 22.0469 13.6021 22.4972C13.8205 22.9474 14.1612 23.3272 14.5853 23.5929C15.0093 23.8587 15.4996 23.9998 16 24"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 5.33331V18.6666"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16 24V26.6667" stroke={strokeColor} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M21.3334 9.33335C21.3334 10.0406 21.6143 10.7189 22.1144 11.219C22.6145 11.7191 23.2928 12 24 12C24.7073 12 25.3856 11.7191 25.8857 11.219C26.3858 10.7189 26.6667 10.0406 26.6667 9.33335C26.6667 8.62611 26.3858 7.94783 25.8857 7.44774C25.3856 6.94764 24.7073 6.66669 24 6.66669C23.2928 6.66669 22.6145 6.94764 22.1144 7.44774C21.6143 7.94783 21.3334 8.62611 21.3334 9.33335Z"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 5.33331V6.66665"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M24 12V16" stroke={strokeColor} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M25.3334 21.3333V29.3333"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3334 25.3333L25.3334 29.3333L21.3334 25.3333"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

ReportsManagerIcon.propTypes = {
  strokeColor: PropTypes.string,
};
